import React from 'react'

import type { IconProps } from './types'

const ZoomOutMap: React.FC<IconProps> = ({
  size = 24,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.432 17.566q.651.652 1.566.652t1.566-.652q.652-.651.652-1.566t-.652-1.566a2.13 2.13 0 0 0-1.566-.652q-.915 0-1.566.652A2.13 2.13 0 0 0 13.78 16q0 .915.652 1.566M6.234 27.17l3.764-3.764v2.928q0 .425.287.713a.97.97 0 0 0 .713.287q.424 0 .712-.287a.97.97 0 0 0 .288-.713v-5.128q0-.511-.346-.859a1.17 1.17 0 0 0-.859-.346H5.665a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712a.97.97 0 0 0 .713.288h2.928L4.83 25.764a.96.96 0 0 0-.29.703q0 .412.29.702t.709.284a.97.97 0 0 0 .696-.284m15.764-.836v-2.928l3.764 3.764q.29.29.703.29t.702-.29a.94.94 0 0 0 .284-.709.97.97 0 0 0-.284-.696L23.403 22h2.928q.425 0 .713-.287A.97.97 0 0 0 27.33 21a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288h-5.128q-.511 0-.859.346-.346.348-.346.859v5.128q0 .425.287.713a.97.97 0 0 0 .713.287q.424 0 .712-.287a.97.97 0 0 0 .288-.713M4.828 6.236 8.594 10H5.665a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712a.97.97 0 0 0 .713.288h5.128q.512 0 .859-.346.345-.347.346-.859V5.667a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713v2.928L6.234 4.831a.96.96 0 0 0-.703-.29.96.96 0 0 0-.702.29.94.94 0 0 0-.284.709q.008.42.284.696M26.332 10h-2.928l3.764-3.764a.96.96 0 0 0 .29-.703.96.96 0 0 0-.29-.702.94.94 0 0 0-.709-.284.97.97 0 0 0-.696.284l-3.764 3.764V5.667a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713v5.128q0 .512.346.859.348.345.86.346h5.127q.425 0 .713-.287A.97.97 0 0 0 27.33 11a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288"
        fill={color}
      />
    </svg>
  )
}

export default ZoomOutMap
